"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _FormRow = _interopRequireDefault(require("./FormRow"));
var _ykbUtils = require("ykb-utils");
var _tableContext = require("../../Context/tableContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function FormRows() {
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var prefixCls = 'ykb-ui-table';
  (0, _react.useEffect)(function () {
    var unsubscriber = [_tableContext.eventHub.on('update.data', setData)];
    return function () {
      unsubscriber.forEach(function (fn) {
        return fn();
      });
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data.map(function (row, rowIndex) {
    if ((0, _ykbUtils.isNullOrUndefined)(row)) return null;
    var rowKey = row['key'];
    // const rowKey =
    //   typeof props.rowKey == 'function' ? props.rowKey(row) : row[props.rowKey];

    return /*#__PURE__*/_react.default.createElement(_FormRow.default, {
      row: row,
      prefixCls: prefixCls,
      rowKey: rowKey,
      key: rowKey,
      rowIndex: rowIndex
      // rowStyle={props.rowStyle}
      ,
      rowSelectionEnable: false
    });
  }));
}

// export default memo(FormRows, () => true);
// export default FormRows;
var FormRows2 = exports.default = /*#__PURE__*/function (_React$PureComponent) {
  function FormRows2() {
    var _this;
    (0, _classCallCheck2.default)(this, FormRows2);
    _this = _callSuper(this, FormRows2);
    _this.setData = _this.setData.bind(_this);
    _this.unsubscriber = [_tableContext.eventHub.on('update.data', _this.setData)];
    _this.state = {
      data: _tableContext.eventHub.getState('data') || []
    };
    return _this;
  }
  (0, _inherits2.default)(FormRows2, _React$PureComponent);
  return (0, _createClass2.default)(FormRows2, [{
    key: "setData",
    value: function setData(_data) {
      var _this2 = this;
      this.setState({
        data: []
      }, function () {
        _this2.setState({
          data: _data
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unsubscriber.forEach(function (fn) {
        return fn();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var prefixCls = 'ykb-ui-table';
      if (this.state.data.length == 0) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.state.data.map(function (row, rowIndex) {
        if ((0, _ykbUtils.isNullOrUndefined)(row)) return null;
        var rowKey = row['key'];
        // const rowKey =
        //   typeof props.rowKey == 'function' ? props.rowKey(row) : row[props.rowKey];

        return /*#__PURE__*/_react.default.createElement(_FormRow.default, {
          row: row,
          prefixCls: prefixCls,
          rowKey: rowKey,
          key: rowKey,
          rowIndex: rowIndex,
          rowStyle: _this3.props.rowStyle
        });
      }));
    }
  }]);
}(_react.default.PureComponent);